import { client } from './client'

export const getAddress = async (params) => {
  const response = await client.get('/api/area/search_address/', { params })
  const data = response.data
  return data
}
